require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./research-tgfb-signaling-pathways.json") })
        }
      }, "path---research-tgfb-signaling-pathways");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---research-tgfb-signaling-pathways!./.cache/json/research-tgfb-signaling-pathways.json
// module id = 491
// module chunks = 231608221292675